module.exports = __webpack_public_path__ + "img/E240.2ce00e9a.svg";